<template>
  <div class="QuestionbankType spackage padding-20 bgc box-shadow">
      <div class="cerate">
          <el-button type="primary" @click="createType">新建分类</el-button>
          <el-button type="primary" @click="gotoBack" plain style="margin-left: 20px;">返回列表</el-button>
      </div>
      <!-- end 新建分类 -->

      <div class="tree">

        <template v-if="!treeData || treeData.length <= 0 || treeData == []">
              <div class="trees null">
                    <img :src="require('@/common/images/other/zwsj@2x.png')" alt="">
                    <span>当前暂无新建分类</span>
              </div>
        </template>
        <!-- end 列表为空 -->
        <template v-else>
            <el-tree class="trees" :data="treeData" node-key="id" :default-expand-all="true" :expand-on-click-node="false">
                <span class="custom-tree-node" slot-scope="{ node, data }">
                    <span>{{ node.label }}</span>
                    <span class="datacount">{{data.datacount}}</span>
                    <span>
                        <el-button class="addchildtype" type="text" size="mini" @click="() => treeCreateChildType(data.id)">添加子分类</el-button>
                        <el-button type="text" size="mini" @click="() => treePosition(data.id)">转移分类</el-button>
                        <el-button type="text" size="mini" @click="() => treeUpdateNameType(data.id, data.label)">重命名</el-button>
                        <el-button type="text" size="mini" @click="() => treeDeleteType(data.id)">删除</el-button>
                    </span>
                </span>
            </el-tree>
        </template>
      </div>
      <!-- 树 -->

    <el-dialog
        :title="dialogName"
        :visible.sync="dialogVisible"
        width="600px"
        :before-close="handleCloseDialog">
        <div class="input">
            <span>分类名称</span><el-input style="width: 343px" v-model="typeName" placeholder="不超过16个字" maxlength="16" />
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleCloseDialog">取 消</el-button>
            <el-button type="primary" @click="clickEditTypeName">确 定</el-button>
        </span>
    </el-dialog>
    <!-- 新建/重命名分类弹窗 -->

    <QuestionbankTypePopu ref="questionbankTypePopu" @returnFatherData="requestChildData" :type="catetype"></QuestionbankTypePopu>
    <!-- 转移分类 -->
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import {getAllHostcatalog, addNewCate, updateCateInfo, deleteCateInfo, moveCateInfo} from 'api/questionApi'
import QuestionbankTypePopu from './components/QuestionbankTypePopu'
export default {
  name: 'QuestionbankType',
  data () {
    return {
        catetype: 1,
        dialogName: '新建分类', // 弹窗提示
        dialogVisible: false, // 弹窗状态
        typeName: '',   // 分类名称
        treeData: [],   // 树列表
        parentcateid: '' // 上级分类id，为空为最顶级
    }
  },
  mounted () {
      this.initTree()
  },
  methods: {
      initTree() {  // 初始化树
        // catetype 存在切换分类
        if (this.$route.query.catetype) {
            this.catetype = 2
        }

        this.setLoading(true)
        getAllHostcatalog({
            data: {
                catetype: this.catetype, // 	题库分类类型： 1试题分类 2试卷分类
                showdefault: 1 // 是否显示未分类：0否 1是
            },
            success: data => {
                // console.log(data)
                this.setLoading(false)

                // if (data.data && data.data.children)
                // for (let i = 1; i < data.data.children.length; i++) {
                //     this.treeData.push(data.data.children[i])
                // }
                this.treeData = data.data.children
                this.$nextTick(() => {
                    for (let i = 0; i < this.treeData.length; i++) {
                        if (this.treeData[i].id == "0") {
                            this.treeData.splice(i, 0)
                            console.log(this.treeData[i])
                            delete this.treeData[i]
                        }
                    }
                })
                // this.treeData.splice(0, 1)

            },
            error: data => {
                this.$message.error(data.msg)
                this.setLoading(false)
            }
        })


      },
      createType() {    // 新建分类
        // 数据初始化
        this._startdialogVisible('新建分类')
        this.parentcateid = ''

      },
      treePosition(parentcateid) {  // 树移动
        this.$refs.questionbankTypePopu.openDialog("转移分类")
        this.parentcateid = parentcateid
      },
      treeCreateChildType(parentcateid) {   // 创建子类
        // 数据初始化
        this._startdialogVisible('新建分类')
        this.parentcateid = parentcateid
      },
      treeUpdateNameType(parentcateid, label) {    // 重命名
        // 数据初始化
        this._startdialogVisible('重命名分类')
        this.typeName = label
        this.parentcateid = parentcateid
      },
      clickEditTypeName() {  // 编辑类别名称
        this._addNewCateApi(this.parentcateid)
      },
      treeDeleteType(cateinnerid) {   // 删除类别
        // 删除弹窗
        this.$confirm('此操作将删除该类别以及其下子类，是否继续？','提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            // type: 'warning'
        }).then(() => {
           deleteCateInfo({
               data: {cateinnerid: cateinnerid},
               success: data => {
                   this.setLoading(false)
                   if (data.code == '000') {
                       this.$message.success('操作成功')
                       this.initTree()  // 初始化类别
                   } else {
                       this.$message.error(data.msg)
                   }
               },
               error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
               }
           })
        }).catch(() => {})
      },
      handleCloseDialog() { // 关闭弹窗
        // 初始化输入域内容
        this.typeName = ''
        // 关闭弹窗
        this.dialogVisible = false
      },
      requestChildData(data) {  // 获取子类返回点方法

            let requestData = JSON.parse(data)

            this.setLoading(true)
            moveCateInfo({
                data: {cateinnerid: this.parentcateid, targetcateid: requestData.id},
                success: data => {
                    this.setLoading(false)
                    this.$message.success('转移分类成功')
                    // 关闭弹窗
                    this.$refs.questionbankTypePopu.closeDialog()
                    this.initTree()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }

            })
            // console.log('子类返回',data)
      },
      gotoBack() {  // 返回上一页
        this.$router.back()
      },
      _addNewCateApi(parentcateid) {    // 编辑分类信息


        if (this.typeName == '' || this.typeName.length == 0) {
            this.$message.error('分类名称不能为空')
            return
        }

        this.setLoading(true)

        if (this.dialogName == '新建分类') {

            addNewCate({
                data: {
                    parentcateid: parentcateid,
                    catetype: this.catetype, // 题库分类类型： 1试题分类 2试卷分类
                    catename: this.typeName // 分类名称，不能为空
                },
                success: data => {
                    this.setLoading(false)
                    // if (parentcateid == '') {
                    this.$message.success('添加成功')
                    // } else {
                        // this.$message.success('编辑成功')
                    // }
                    // 关闭弹窗
                    this.handleCloseDialog()
                    this.initTree()

                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })


        } else if (this.dialogName == '重命名分类') {

            updateCateInfo({
                data: {
                    cateinnerid: parentcateid,
                    catetype: this.catetype, // 题库分类类型： 1试题分类 2试卷分类
                    catename: this.typeName // 分类名称，不能为空
                },
                success: data => {
                    this.setLoading(false)
                    // if (parentcateid == '') {
                        // this.$message.success('添加成功')
                    // } else {
                    this.$message.success('编辑成功')
                    // }
                    // 关闭弹窗
                    this.handleCloseDialog()
                    this.initTree()

                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })

        }



      },

      _startdialogVisible(title) {   // 开启弹窗
        this.dialogName = title // 初始化弹窗提示标题
        this.typeName = ''  // 初始化输入域内容
        this.dialogVisible = true   // 开启弹窗
      },
      ...mapActions(['setLoading'])
  },
  filters: {},
  watch: {},
  computed: {},
  components: {
      QuestionbankTypePopu
  }
}
</script>

<style lang="scss" type="text/scss" scope>
.input {
    margin-left: 60px;
    margin-top: 40px;
    margin-bottom: 30px;

    span {
        margin-right: 20px
    }

    input {
        width: 100%;
    }
}
.QuestionbankType {
    .el-tree-node {
        .el-tree-node__children {
            .el-tree-node__children {
                .el-tree-node {
                    .addchildtype {
                        display: none;
                    }
                    .el-button:nth-child(2)::after {
                        content: '';
                    }
                }
            }
        }
    }
    .trees {
        position: relative;
        margin-top: 30px;
        border: solid 1px #e5e5e5;
        min-height: 500px;
        // overflow-y: auto;

        .el-tree-node__content {
            height: 40px;
             &:hover {
                span:last-child {
                    display: block;
                }
            }
        }
        .datacount {
            margin-left: 12px;
            font-size: 12px;
            color: #909399;
        }
        .custom-tree-node {
            padding-right: 24px;
            width: 100%;
            font-size: 14px;
            line-height: 32px;


            span:last-child {
                display: none;
                float: right;
            }

            .el-button {
                // margin-right: 10px;
                min-width: auto;

                &::after {
                    content: '|';
                    color: #409EFF;
                    padding-right: 10px;
                }
                &:nth-child(1)::after {
                    content: '';
                }
            }
        }
    }
    .null {
        text-align: center;
        img {
            display: block;
            margin: auto;
            margin-top: 89px;
            width: 372px;
            height: 269px;
        }
        span {
            font-size: 20px;
            text-align: center;
            color: #606266;
        }
    }
}

.el-dialog__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: left;
}
.el-dialog {
    /*margin: 0!important;*/
}
.el-dialog .el-dialog__body {
    padding: 6px;
    // padding-right: 6px;
}
.dialog-footer {
    .el-button+.el-button {
        margin-left: 20px;
    }
}
</style>
